<etoh-page-form
  [dataType]="'companies'"
  [name]="'Company'"
  [id]="id"
  [standalone]="standalone"
  [fields]="fields"
  [dataTabs]="dataTabs"
  [insertFunction]="upsertCompany"
  [updateFunction]="upsertCompany"
  (loaded)="onLoaded()"
  [afterGetModel]="afterGetModel"
  [shouldPrevent]="shouldPrevent"
>
</etoh-page-form>
